/**
 * Whether the embed UI mode is on (hide app header/footer).
 * Accepts Next.js router / context.query shapes.
 */
export function isEmbedActive(value: unknown): boolean {
  if (value === true) {
    return true;
  }
  if (value === undefined || value === null) {
    return false;
  }
  const token = Array.isArray(value) ? value[0] : value;
  if (typeof token === 'boolean') {
    return token;
  }
  if (typeof token !== 'string') {
    return false;
  }
  return token === 'true' || token === '1';
}
